import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=0a45f4fc&scoped=true&"
import script from "./CaseList.vue?vue&type=script&lang=ts&"
export * from "./CaseList.vue?vue&type=script&lang=ts&"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=0a45f4fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45f4fc",
  null
  
)

export default component.exports